import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Box,
} from "@material-ui/core";
import {Workflow} from "common/flowmaster/types/workflow";

const styles = {
  container: {
    border: "1px solid #ddd",
    borderRadius: 4,
    padding: "1em",
    display: "flex",
    flexDirection: "column",
    gap: "1em",
    marginBottom: "1em",
  },
  sectionLabel: {
    display: "flex",
    alignItems: "center",
    height: "48px",
    fontWeight: "bold",
  },
  formControl: {
    width: "100%",
    maxWidth: 500,
  },
} as const;

interface DefinitionSectionProps {
  definitions: Workflow[];
  selectedDefinitionId: number | string;
  handleDefinitionChange: (event: React.ChangeEvent<{value: unknown}>) => void;
}

const DefinitionSection: React.FC<DefinitionSectionProps> = ({
  definitions,
  selectedDefinitionId,
  handleDefinitionChange,
}) => {
  return (
    <Box style={styles.container}>
      <Typography variant="body1" style={styles.sectionLabel}>
        Definitions
      </Typography>

      <FormControl variant="outlined" style={styles.formControl}>
        <InputLabel id="definition-selector-label">
          Select Definition
        </InputLabel>
        <Select
          value={selectedDefinitionId}
          onChange={handleDefinitionChange}
          label="Select Definition"
        >
          <MenuItem value="">
            <em>-- Select a definition --</em>
          </MenuItem>
          {definitions.map(definition => (
            <MenuItem key={definition.id} value={definition.id}>
              {definition.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default DefinitionSection;
